import ThemeColors from "../colors";

const typography = {
    fontFamily: '"Basis Grotesque Arabic", sans-serif',
    h1: {
        fontSize: "40px",
        fontWeight: 700,
        '@media (max-width:900px)': {
            fontSize: "30px",
        },
    },
    h2: {
        fontSize: "36px",
        fontWeight: 900,
        color: ThemeColors.redColor,
        '@media (max-width:900px)': {
            fontSize: "30px",
        },
    },
    h3: {
        fontSize: "24px",
        fontWeight: 800,
        '@media (max-width:900px)': {
            fontSize: "22px",
        },
    },
    h4: {
        fontSize: "22px",
        fontWeight: 700,
        '@media (max-width:900px)': {
            fontSize: "20px",
        },
    },
    h5: {
        fontSize: "20px",
        fontWeight: 600,
        '@media (max-width:900px)': {
            fontSize: "18px",
        },
    },
    h6: {
        fontSize: "18px",
        fontWeight: 500,
        '@media (max-width:900px)': {
            fontSize: "16px",
        },
    },
    body1: {
        fontSize: "16px",
        fontWeight: 500,
        '@media (max-width:900px)': {
            fontSize: "14px",
        },
    },
    body2: {
        fontSize: "14px",
        fontWeight: 400,
        '@media (max-width:900px)': {
            fontSize: "12px",
        },
    },
    caption: {
        fontSize: "12px",
        fontWeight: 300,
        '@media (max-width:900px)': {
            fontSize: "10px",
        },
    },
    subtitle1: {
        fontSize: "10px",
        fontWeight: 300,
        textDecoration: "underline",
        '@media (max-width:900px)': {
            fontSize: "10px",
        },
    },
    subtitle2: {
        fontSize: "8px",
        fontWeight: 300,
        '@media (max-width:900px)': {
            fontSize: "10px",
        },
    },
    button: {
        color: ThemeColors.brandingRed,
        borderRadius: 30,
        textTransform: "none",
        fontSize: 16,
        '@media (max-width:900px)': {
            fontSize: 14,
        },
    },
};

export default typography;